import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectPartnersType = createSelector(
  [selectComposedReportState],
  ({ partnersType }) => partnersType
)
